
import { Component, Prop, Vue } from "vue-property-decorator";
import JieLongCard from "@/components/JieLongCard/index.vue";
import SearchBar from "@/components/SearchBar/index.vue";
import { getJielongList, getJielongDraft, JieLongCardInfo, JieLongStatus, JIELONG_STATUS } from "@/api/jielong";
import AddCopyJielongPop from "@/views/jielong/components/AddCopyJielongPop.vue";
import { Getter } from "vuex-class";

interface TabItem {
  label: string;
  value: "" | JieLongStatus;
}

@Component({
  components: { JieLongCard, AddCopyJielongPop, SearchBar },
})
export default class JieLongList extends Vue {
  @Prop({ type: Boolean, default: false }) copyMode!: boolean;

  list: JieLongCardInfo[] = [];
  activeStatus: "" | JieLongStatus = "";
  queryContent = "";

  pageIndex = 1;
  pageSize = 10;
  loading = false;
  finished = false;
  refreshing = false;
  draftJoinActivityId = "";

  @Getter companyId!: string;

  readonly tabs: TabItem[] = [
    { label: "全部", value: "" },
    { label: "接龙中", value: JIELONG_STATUS.ONGOING },
    { label: "未开始", value: JIELONG_STATUS.NOT_STARTED },
    { label: "已结束", value: JIELONG_STATUS.ENDED },
  ];

  mounted (): void {
    // 首次进入只走列表 loading，不走下拉刷新态，避免叠两个「加载中」
    this.loading = true;
    this.loadList();
    this.loadDraftStatus();
  }

  loadDraftStatus (): void {
    getJielongDraft({ storeId: this.companyId })
      .then((res) => {
        this.draftJoinActivityId = res.data?.joinActivityId || "";
      })
      .catch(() => {
        this.draftJoinActivityId = "";
      });
  }

  onRefresh (): void {
    this.pageIndex = 1;
    this.finished = false;
    this.refreshing = true;
    // 下拉刷新时需同步锁定 van-list，否则 finished=false 且 loading=false 会立刻再触发 @load
    this.loading = true;
    this.loadList();
  }

  onLoad (): void {
    // 刷新进行中忽略 load，避免与 pageIndex=1 的请求交错
    if (this.refreshing) return;
    this.pageIndex += 1;
    this.loadList();
  }

  onStatusClick (status: "" | JieLongStatus): void {
    if (this.activeStatus === status) return;
    this.activeStatus = status;
    this.onRefresh();
  }

  onSearch (): void {
    this.onRefresh();
  }

  loadList (): void {
    const params: Parameters<typeof getJielongList>[0] = {
      storeId: this.companyId,
      pageIndex: this.pageIndex,
      pageSize: this.pageSize,
      source: 1,
    };
    if (this.activeStatus !== "") {
      params.status = this.activeStatus;
    }
    const title = this.queryContent.trim();
    if (title) {
      params.title = title;
    }

    getJielongList(params)
      .then((res) => {
        const data = res.data;
        const records = data?.records || [];
        if (this.refreshing || this.pageIndex === 1) {
          this.list = [];
        }
        this.list = this.list.concat(records);
        if (this.pageIndex >= (data?.totalPages || 1) || records.length < this.pageSize) {
          this.finished = true;
        } else {
          this.finished = false;
        }
      })
      .catch(() => {
        this.finished = true;
      })
      .finally(() => {
        this.loading = false;
        this.refreshing = false;
      });
  }

  onAdd (): void {
    this.loadDraftStatus();
    (this.$refs.addCopyJielongPop as any).onOpen();
  }

  onCopy (info: JieLongCardInfo): void {
    this.$emit("copy", info);
  }
}
